import RouterService from '@ember/routing/router-service';

export default class ExtendedRouterService extends RouterService {
  async clearAllQueryParams() {
    const queryParams = { ...(this.currentRoute?.queryParams ?? {}) };
    Object.keys(queryParams).forEach((key) => {
      queryParams[key] = undefined;
    });
    await this.transitionTo({ queryParams });
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:router')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('router') declare altName: RouterService;`.
declare module '@ember/service' {
  interface Registry {
    router: RouterService;
  }
}
